// extracted by mini-css-extract-plugin
export default {"default_btn_style":"Button_default_btn_style__U8gMI"};